import axios from 'axios';

let lang = {};
import langFallback from '@data/label';
import { OrderItem, Config, WishlistCatentry, Attr } from '@store/wishlist/wishlistInterfaces';
import urlList from './urlList';
import labelList from '../data/label';
import { badgeLabels } from './const';

type urls = keyof typeof urlList;
export type labels = keyof typeof labelList;

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const getLabels = async (langUrl: string) => {
  if (langUrl) {
    await axios
      .get(langUrl)
      .then(function (response) {
        lang = response.data;
      })
      .catch(function (error) {
        console.error('>>> Get labels => error status:', error.status, ', error: ', error);
      });
  }
};

export const getLabelFallback = (label: labels): string => {
  if (lang && lang[label]) return lang[label];
  if (langFallback && langFallback[label]) return langFallback[label];
  return '';
};

export const convertNumber = (value: string | number): string => {
  return parseFloat(value.toString()).toFixed(2);
};

export const getItemTotalPrice = (item: OrderItem): string => {
  return convertNumber(
    parseFloat(item?.frame?.finalPrice ? item.frame.finalPrice.toString() : '0') +
      parseFloat(!!item?.lenses?.finalPrice ? item.lenses.finalPrice : '0') +
      parseFloat(!!item?.addOns?.finalPrice ? item.addOns.finalPrice : '0')
  );
};

export const getItemDiscountedTotalPrice = (item: OrderItem): string => {
  return convertNumber(
    parseFloat(!!item?.frame?.finalDiscountPrice ? item.frame.finalDiscountPrice.toString() : '0') +
      parseFloat(!!item?.lenses?.finalDiscountPrice ? item.lenses.finalDiscountPrice : '0') +
      parseFloat(!!item?.addOns?.finalDiscountPrice ? item.addOns.finalDiscountPrice : '0')
  );
};

export const getItemUnitTotalPrice = (item: OrderItem): string => {
  return convertNumber(parseFloat(item.frame.xitem_basePrice));
};

export const getItemUnitDiscountedTotalPrice = item => {
  return convertNumber(parseFloat(item.frame.unitPrice));
};

export const getUrl = (config: Config, url: urls) => {
  return (
    config.hostname +
    urlList[url].replace('{storeId}', config.storeId).replace('{catalogId}', config.catalogId)
  );
};

export const isValidJson = (str: string) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const getContactDetail = (item, position: 'left' | 'right', type) => {
  let defaultValue = '--';
  return !!item[position + 'Contact'][type] ? item[position + 'Contact'][type] : defaultValue;
};

export const atLeastOneEqual = (str: string, arr: string[]) => {
  return arr.some(item => item === str);
};

/* getInnerProperties - this function is used to get all the properties of a frame or a lenses */
export const getInnerProperties = (frame, type) => {
  let obj = {};
  if (frame && frame.CatalogEntryView[0] && frame.CatalogEntryView[0].Attributes) {
    frame.CatalogEntryView[0].Attributes.forEach(attr => {
      obj[attr.name.toLowerCase().replace(/ /g, '')] = attr.Values[0].values;
    });

    obj['buyable_' + type] = frame.CatalogEntryView[0].buyable ?? '';
    obj['partNumber_' + type] = frame.CatalogEntryView[0].partNumber ?? '';
  }
  return obj;
};

/* getInfoContact -  this function is used to retrieve all information for contanct lenses from an items */
export const getInfoContact = item => {
  return {
    ...getInnerProperties(item, 'frame'),
  };
};

/* getLeftContact -  this function is used to retrieve all information for a contanct lenses */
export const getContact = (contactFrame, lens: WishlistCatentry, eye: 'left' | 'right') => {
  const catEntryId = lens?.catEntryId;
  if (catEntryId) {
    const infoContact = getInfoContact(contactFrame);
    return {
      [eye + 'Contact']: {
        ...infoContact,
        catEntryId,
        quantity: lens.quantity,
      },
    };
  }
  return {
    [eye + 'Contact']: {},
  };
};

export const getPriority = (extendedValue) => {
  let value = '';
  if (!!extendedValue) {
    extendedValue.map(element => {
      if (element.key === 'AttributeField2') {
        value = element.value;
      }
    })
  }
  return value;
}

export const getPosition = (extendedValue) => {
  let value = '';
  if (!!extendedValue) {
    extendedValue.map(element => {
      if (element.key === 'AttributeField1') {
        value = element.value;
      }
    })
  }
  return value;
}

export const getBadge = (attributes: any[]) => {
  let badgesStr = '';
  
  attributes.map(element => {
    switch (element.identifier) {
      case 'BADGE_NEW_ARRIVAL':
      case 'IS_NEW':
        if (!!element && !!element.Values && !!element.Values[0] && !!element.Values[0].values &&  (element.Values[0].values.toUpperCase() === 'TRUE' || (element.Values[0].values=="1"))) {
          badgesStr +=  ('BADGE_NEW_ARRIVAL-' + getPriority(element.extendedValue) + '-' + getPosition(element.extendedValue) + ':');
        }
        break;
      case 'AVANT_PREMIER':
        if (!!element && !!element.Values && !!element.Values[0] && !!element.Values[0].values &&  element.Values[0].values.toUpperCase() === 'TRUE') {
          badgesStr +=  ('AVANT_PREMIER-' + getPriority(element.extendedValue) + '-' + getPosition(element.extendedValue) + ':');
        }
        break;
      case 'BADGE_BEST_SELLER':
      case 'IS_BESTSELLER':
        if (!!element && !!element.Values && !!element.Values[0] && !!element.Values[0].values &&  (element.Values[0].values.toUpperCase() === 'TRUE' || (element.Values[0].values=="1"))) {
          badgesStr +=  ('BADGE_BEST_SELLER-' + getPriority(element.extendedValue) + '-' + getPosition(element.extendedValue) + ':');
        }
        break;
      case 'BADGE_EXCLUSIVE':
      case 'EXCLUSIVE':
        if (!!element && !!element.Values && !!element.Values[0] && !!element.Values[0].values &&  element.Values[0].values.toUpperCase() === 'TRUE') {
          badgesStr +=  ('BADGE_EXCLUSIVE-' + getPriority(element.extendedValue) + '-' + getPosition(element.extendedValue) + ':');
        }
        break;
      case 'LIMITED_EDITION':
        if (!!element && !!element.Values && !!element.Values[0] && !!element.Values[0].values &&  element.Values[0].values.toUpperCase() === 'TRUE') {
          badgesStr +=  ('LIMITED_EDITION-' + getPriority(element.extendedValue) + '-' + getPosition(element.extendedValue) + ':');
        }
        break;
      case 'POLARIZED':
        if (!!element && !!element.Values && !!element.Values[0] && !!element.Values[0].values && ( element.Values[0].values.toUpperCase() === 'YES' || element.Values[0].values.toUpperCase() === 'TRUE')) {
          badgesStr +=  ('POLARIZED-' + getPriority(element.extendedValue) + '-' + getPosition(element.extendedValue) + ':');
        }
        break;
      case 'GEOFIT':
        if (!!element && !!element.Values && !!element.Values[0] && !!element.Values[0].values &&  element.Values[0].values.toUpperCase() === 'UNIVERSAL FIT') {
          badgesStr +=  ('GEOFIT-' + getPriority(element.extendedValue) + '-' + getPosition(element.extendedValue) + ':');
        }
        break;
      case 'FRAME_LENS_TREATMENT':
      case 'LENS_TREATMENT_FACET':
        if (!!element && !!element.Values && !!element.Values[0] && !!element.Values[0].values &&  element.Values[0].values.toUpperCase().includes('PHOTOCHROMIC') || !!element && !!element.Values && !!element.Values[0] && !!element.Values[0].values &&  element.Values[0].values.toUpperCase().includes('TRANSITIONS')) {
          badgesStr +=  ('FRAME_LENS_TREATMENT-' + getPriority(element.extendedValue) + '-' + getPosition(element.extendedValue) + ':');
        }
        break;
      case 'SUSTAINABILITY_CLAIM':
        if (!!element && !!element.Values && !!element.Values[0] && !!element.Values[0].values &&  element.Values[0].values.toUpperCase() === 'TRUE') {
          badgesStr +=  ('SUSTAINABILITY_CLAIM-' + getPriority(element.extendedValue) + '-' + getPosition(element.extendedValue) + ':');
        }
        break;
      case 'BADGE':
        if (!!element && !!element.Values && !!element.Values[0] && !!element.Values[0].values &&  element.Values[0].values.toUpperCase() === 'KIDS') {
          badgesStr +=  ('BADGE-' + getPriority(element.extendedValue) + '-' + getPosition(element.extendedValue) + ':');
        }
        break;
      case 'ELECTRONICS':
        badgesStr +=  ('ELECTRONICS-99-99');
        break;
      case 'PRODUCT_TYPE':
        if (!!element && !!element.Values && !!element.Values[0] && !!element.Values[0].values &&  element.Values[0].values.toUpperCase() === 'ELECTRONICS') {
          badgesStr +=  ('ELECTRONICS-99-99');
        }
        break;  
      default:
        break;
    }
  });
  let primary;
  let secondary;

  let badges = badgesStr.split(":")
				.filter(s => s.length)
				.map(s => s.split("-")) // format: [[ID, priority, position], [...], ...]
				.sort((a, b) => {
					// smart glasses always go in front of everything
					if (a[0] == 'ELECTRONICS')
						return -1
					else if (b[0] == 'ELECTRONICS')
						return 1
					else
						return parseInt(a[1]) - parseInt(b[1])
				})

  primary = badges.filter(b => +b[2] < 2).slice(0, 1).map(b => badgeLabels[b[0]]);
  secondary = badges.filter(b => +b[2] >= 2).slice(0, 2).map(b => badgeLabels[b[0]]);
  if (secondary[0] == badgeLabels['ELECTRONICS'])
    secondary = [badgeLabels['ELECTRONICS']] // only display smart glasses

  return { primary: primary, secondary: secondary };
}
